import React from "react";
import classNames from "classnames/bind";
import styles from "./loader.module.scss";
import loading from "../../assets/images/icons/loading.svg";

const cx = classNames.bind(styles);

interface LoaderProps {
  isOpen?: boolean;
  className?: string;
  topShift?: number;
}

class Loader extends React.Component<LoaderProps> {
  public static defaultProps: LoaderProps = {
    isOpen: false,
    className: "large",
    topShift: -1,
  };

  render() {
    const { isOpen, className, topShift = 0 } = this.props;

    return isOpen ? (
      <div
        style={{
          height: `calc(100% - ${topShift + 1}px)`,
          top: `${topShift + 1}px`,
        }}
        className={cx("wrapper", (className || "").split(" "))}
      >
        <img src={loading} alt="" className={styles.icon} />
      </div>
    ) : null;
  }
}

export default Loader;
